const emptyToUndefined = (value: string) => {
  const trimmedValue = value.trim()

  return trimmedValue || undefined
}

const normalizeWebsite = (website: string) => {
  const normalizedValue = emptyToUndefined(website)

  if (!normalizedValue) return undefined

  return normalizedValue.startsWith('http://') || normalizedValue.startsWith('https://')
    ? normalizedValue
    : `https://${normalizedValue}`
}

const buildAddress = ({
  address,
  address_second_line,
  city,
  country,
  postcode,
}: {
  address: string
  address_second_line: string
  city: string
  country: string
  postcode: string
}) => {
  const nextAddress = {
    address: emptyToUndefined(address),
    address_second_line: emptyToUndefined(address_second_line),
    city: emptyToUndefined(city),
    country: emptyToUndefined(country),
    postcode: emptyToUndefined(postcode),
  }

  return Object.values(nextAddress).some(Boolean) ? nextAddress : undefined
}

export { buildAddress, emptyToUndefined, normalizeWebsite }
